import { api, tokenManager } from "../api";
import {
  AppleLoginRequest,
  AppleRegisterRequest,
  AuthResponse,
  AuthUser,
  GoogleRegisterRequest,
  RegisterRequest,
} from "./type";

export const AuthService = {
  async login(email: string, password: string): Promise<AuthResponse> {
    const response = await api.post<AuthResponse>("/auth/login", {
      email,
      password,
    });
    if (response.accessToken) {
      tokenManager.set(response.accessToken);
    }
    return response;
  },
  async register(data: RegisterRequest): Promise<AuthResponse> {
    const response = await api.post<AuthResponse>("/auth/register", data);
    if (response.accessToken) {
      tokenManager.set(response.accessToken);
    }
    return response;
  },

  async googleRegister(data: GoogleRegisterRequest): Promise<AuthResponse> {
    const response = await api.post<AuthResponse>(
      "/auth/google-register",
      data,
    );
    if (response.accessToken) {
      tokenManager.set(response.accessToken);
    }
    return response;
  },

  async appleLogin(data: AppleLoginRequest): Promise<AuthResponse> {
    const response = await api.post<AuthResponse>("/auth/apple", data);
    if (response.accessToken) {
      tokenManager.set(response.accessToken);
    }
    return response;
  },

  async appleRegister(data: AppleRegisterRequest): Promise<AuthResponse> {
    const response = await api.post<AuthResponse>("/auth/apple-register", data);
    if (response.accessToken) {
      tokenManager.set(response.accessToken);
    }
    return response;
  },

  async getMyProfile(): Promise<AuthUser | null> {
    try {
      if (!this.isAuthenticated()) {
        return null;
      }
      const response = await api.get<{ user: AuthUser }>("/auth/me");
      return response.user;
    } catch (error) {
      tokenManager.clear();
      return null;
    }
  },
  logout() {
    tokenManager.clear();
    window.location.href = "/";
  },
  isAuthenticated(): boolean {
    return tokenManager.get() !== null;
  },
};
